import { Select } from 'antd';
import React from 'react';

const crtOptions = [
  {
    label: 'Simples Nacional',
    value: 'simplesNacional'
  },
  {
    label: 'Simples Nacional - Excesso Sublimite Receita Bruta',
    value: 'simplesNacionalExcessoSublimite'
  },
  {
    label: 'Regime Normal',
    value: 'regimeNormal'
  },
  {
    label: 'Simples Nacional - MEI',
    value: 'simplesNacionalMEI'
  }
];

const SelectTaxRegime = (props) => {
  return (
    <Select {...props}>
      {crtOptions.map((option) => (
        <Select.Option key={option.value} value={option.value}>
          {option.label}
        </Select.Option>
      ))}
    </Select>
  );
};

export default SelectTaxRegime;
